export default __webpack_public_path__ + "static/DSC_0007-e143509fa6d2a75ef11bbf0ce647991d.jpg";